import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogCategory, LoggerService, LogPage, LogType } from 'src/app/core/services/logger.service';
import { ProfileService } from '../../../core/services/profile.service';

@Component({
    selector: 'bid-confirm-modal',
    templateUrl: './bid-confirm-modal.component.html',
    styleUrls: ['./bid-confirm-modal.component.scss'],
    standalone: false
})
export class BidConfirmModalComponent {

    @Input() section: any;
    @Input() auction: any;
    public bidpoints: number = 0;
    public pointserror: boolean;

    constructor(
        private logger: LoggerService,
        public activeModal: NgbActiveModal,
        public profileService: ProfileService,
    ) {
        this.log("constructor", "", LogCategory.Constructor);

    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Page, LogPage.CourseCatalog, category);
    }

    public placeBid(bidpoints) {
        if (bidpoints > this.auction.CurrentBidPoints) {
            this.pointserror = true;
        } else {
            this.pointserror = false;
            this.activeModal.close(bidpoints);
        }
        
    }

    public validate() {        
        if (this.bidpoints > this.auction.CurrentBidPoints) {
            this.pointserror = true;
        } else {
            this.pointserror = false;
        }
    }

}
